import React from 'react';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faListAlt } from '@fortawesome/pro-solid-svg-icons/faListAlt';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { Box, usePage } from 'bumbag';

import { Sidebar as _Sidebar } from '@medipass/react-core';
import { SidebarNavItem } from '@medipass/react-core';

import SidebarFooter from './SidebarFooter';
type Props = {
  userMenuProps: Record<string, any>;
  username: string;
};

function Sidebar(props: Props) {
  const { userMenuProps, username } = props;
  const page = usePage();
  return (
    <_Sidebar
      addonComponentBefore={
        page.sidebar.isMinimized ? undefined : (
          <Box color="white" fontWeight="semibold" paddingLeft="major-2" paddingRight="major-2" paddingBottom="major-2">
            {username}
          </Box>
        )
      }
      userMenuProps={{
        username,
        ...userMenuProps,
      }}
    >
      <Box>
        <SidebarNavItem exact route="/account/transactions/" icon={faListAlt} matchRoutes={['/']}>
          Transactions
        </SidebarNavItem>
        <SidebarNavItem exact route="/account/quotes/" icon={faEnvelope}>
          Quotes
        </SidebarNavItem>
        <SidebarNavItem exact route="/account/members/" icon={faUser}>
          Member details
        </SidebarNavItem>
        <SidebarNavItem exact route="/account/payment-methods/" icon={faCreditCard}>
          Payment methods
        </SidebarNavItem>
      </Box>
      {!page.sidebar.isMinimized && (
        <Box marginTop="major-2">
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <SidebarFooter color="white" textAlign="center" />
        </Box>
      )}
    </_Sidebar>
  );
}

export default Sidebar;
